// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"74a836db","769":"6ca0ae36"}[chunkId] + ".chunk.js";
};